import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective } from '@ngx-translate/core';
import { PlatformService, PreferencesService, UserPreferences } from '@tdwb/core';

@Component({
  selector: 'td-wb-responsive-option',
  templateUrl: 'responsive-option.component.html',
  styleUrls: ['responsive-option.component.scss'],
  imports: [
    TranslateDirective
  ]
})
export class ResponsiveOptionComponent {
  private readonly preferencesService = inject(PreferencesService);
  private readonly platformService = inject(PlatformService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  isSmallScreen: boolean;
  usingResponsive: boolean;

  constructor() {
    this.usingResponsive = this.preferencesService.getPreloadedUserPreference<boolean>('USING_RESPONSIVE');
    this.isSmallScreen = this.platformService.isMobileOrTabletPortraitView();
    this.platformService.onScreenSizeChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((): void => {
        this.isSmallScreen = this.platformService.isMobileOrTabletPortraitView();
        this.changeDetectorRef.markForCheck();
      });
  }

  toggle(): false {
    this.preferencesService.toggleResponsivePreference().subscribe((userPreferences: UserPreferences): void => {
      this.usingResponsive = userPreferences.USING_RESPONSIVE as boolean;
      this.changeDetectorRef.markForCheck();
    });
    return false;
  }
}
